import { FC } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import EXTRA_QUESTION_LABELS from '../../../../constants/extraQuestions'
import { Radio, RadioGroup } from '../../../../shared/compass-ui'
import HiddenFieldMirror from '../../../shared/HiddenFieldMirror'
import TextInputError from '../../../shared/TextInputError'

const CREDIT_REPAIR_OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
]

const CreditRepair: FC = () => {
  const {
    formState: {
      errors: { creditRepair: creditRepairError },
    },
  } = useFormContext()

  const creditRepairValue = useWatch({ name: 'creditRepair' })
  const hasError = typeof creditRepairError?.message === 'string'

  return (
    <div className="col-span-full md:col-span-3">
      <HiddenFieldMirror name="creditRepair" />
      <RadioGroup
        label={EXTRA_QUESTION_LABELS.creditRepair}
        hasError={hasError}
        id="credit-repair-radio-group"
        data-testid="credit-repair-radio-group"
      >
        {CREDIT_REPAIR_OPTIONS.map((option, idx) => (
          <Radio
            key={`credit-repair-${option.value}`}
            {...option}
            idx={idx}
            hasError={hasError}
            name="creditRepair"
            selectedValue={creditRepairValue ?? null}
          />
        ))}
      </RadioGroup>
      {hasError && <TextInputError>This field is required</TextInputError>}
    </div>
  )
}

export default CreditRepair
